"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactTray = void 0;
exports.default = ContactTrayWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _componentUtilities = require("@ux/component-utilities");
var _enums = require("./enums");
var _eid = _interopRequireDefault(require("./eid"));
var _trayMenu = require("@ux/tray-menu");
var _link = _interopRequireDefault(require("@ux/link"));
var _information = _interopRequireDefault(require("@ux/icon/information"));
var _phone = _interopRequireDefault(require("@ux/icon/phone"));
var _chat = _interopRequireDefault(require("@ux/icon/chat"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Render and expose the LanguageSelector as a functional Component.
 *
 * @api public
 * @param {Object} props Properties
 */
class ContactTray extends _react.Component {
  constructor(props) {
    super(...arguments);
    this.eids = {
      contactUs: (0, _eid.default)({
        key: _enums.golf.contactUs,
        manifest: props.manifest
      }),
      globalDirectory: (0, _eid.default)({
        key: _enums.golf.globalDirectory,
        manifest: props.manifest
      }),
      help: (0, _eid.default)({
        key: _enums.golf.help,
        manifest: props.manifest
      })
    };
    this.showSupportContacts = this.showSupportContacts.bind(this);
    this.state = {
      showPhoneNumbers: false
    };
  }
  render() {
    const props = this.props;
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, this.renderInternal());
  }

  /**
   * Render contact tray menu or link
   * @returns {React.ReactElement} tray menu or link
   */
  renderInternal() {
    const props = this.props;
    const supportDetails = props.supportContacts || {};
    const phoneNumber = supportDetails.technicalSupportPhone || '';

    // technicalSupportPhoneDisplayOnly enables a different display number (displayed) than technicalSupportPhone (dialed)
    const trayName = supportDetails.technicalSupportPhoneDisplayOnly || supportDetails.technicalSupportLabel; /* eslint id-length: ["error", { "exceptions": ["32"] }]*/
    const telHref = `tel:${phoneNumber.replace(/[^+\d]/g, '')}`;
    let showContactTrayForHelpCenter = true;
    if (props.privateLabelId === 1) {
      showContactTrayForHelpCenter = typeof props.features.showContactTrayForHelpCenter === 'boolean' ? props.features.showContactTrayForHelpCenter : true;
    }
    if (!trayName || trayName === '') {
      return /*#__PURE__*/_react.default.createElement("div", null);
    }
    const includesPhoneNumber = this.includesPhoneNumber(trayName, phoneNumber, supportDetails);

    // Below added for https://godaddy-corp.atlassian.net/browse/UXP-8209
    if (!showContactTrayForHelpCenter) {
      var _props$features, _this$props, _this$props$urls, _this$props$urls$help;
      const href = (props === null || props === void 0 ? void 0 : (_props$features = props.features) === null || _props$features === void 0 ? void 0 : _props$features.contactTrayHelpLink) || ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$urls = _this$props.urls) === null || _this$props$urls === void 0 ? void 0 : (_this$props$urls$help = _this$props$urls.helpCenterContactUs) === null || _this$props$urls$help === void 0 ? void 0 : _this$props$urls$help.href) || 'https://godaddy.com/help/contact-us';
      return this.renderLink(trayName, includesPhoneNumber, href, showContactTrayForHelpCenter);
    }
    if (props.privateLabelId === 1) {
      if (props.contactTrayEnabled) {
        return this.renderFullTray(supportDetails, trayName, includesPhoneNumber);
      }
      if (this.shouldShowCityContactsTray(supportDetails)) {
        return this.renderCityContactsTray(supportDetails, trayName, telHref, includesPhoneNumber);
      }
    }

    // If none of the trays are enabled, just show the tray name as a link
    // If {phone} make the number a telHref otherwise link to contact us
    const trayNameEid = includesPhoneNumber ? `uxp.hyd.utility_bar.support_phone.click` : this.eids.contactUs;
    let trayHref = props.urls.contactUs.href;
    if (includesPhoneNumber) {
      trayHref = telHref;
    } else if (props.privateLabelId !== 1) {
      trayHref = '#';
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "basic-phone-container"
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      urlArgs: props.urlArgs,
      href: trayHref,
      className: "basic-phone-btn",
      "data-eid": trayNameEid
    }, this.renderTrayName(trayName, includesPhoneNumber)));
  }

  /**
   * Renders Link instead of tray. Originally made for help center experiment to not show help phone number
   * https://godaddy-corp.atlassian.net/browse/UXP-8209.
   * @param  {String} trayName The translated text to display as the tray name
   * @param {Boolean} includesPhoneNumber whether or not the tray label includes the support number
   * @param  {String} href The href pointing to a contact-us page for selected countries
   * @param {Boolean} showContactTrayForHelpCenter whether there is a dropdown tray or contact-us link
   * @returns {React.ReactElement} div containing tray name
   * @private
   */
  renderLink(trayName, includesPhoneNumber, href, showContactTrayForHelpCenter) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "basic-phone-container"
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      urlArgs: this.props.urlArgs,
      href: href,
      target: "_blank",
      className: "basic-phone-btn",
      "data-eid": this.eids.contactUs
    }, this.renderTrayName(trayName, includesPhoneNumber, showContactTrayForHelpCenter)));
  }

  /**
   * Renders name to display on contact tray
   * @param  {String} trayName The translated text to display as the tray name
   * @param {Boolean} includesPhoneNumber whether or not the tray label includes the support number
   * @param {Boolean} showContactTrayForHelpCenter whether there is a dropdown tray or contact-us link
   * @returns {React.ReactElement} div containing tray name
   * @private
   */
  renderTrayName(trayName, includesPhoneNumber) {
    let showContactTrayForHelpCenter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ((0, _componentUtilities.isMobile)(this.props.breakpoint) || this.props.breakpoint === 'tablet' || includesPhoneNumber && showContactTrayForHelpCenter) && this.renderIcon(showContactTrayForHelpCenter), /*#__PURE__*/_react.default.createElement("span", {
      className: "basic-phone-text title-text"
    }, trayName));
  }

  /**
   * Check if tray name includes the phone number
   * @param {String} trayName contact tray label
   * @param {String} phoneNumber the technical support number
   * @param {Object} supportDetails Information from the support API
   * @returns {Boolean} true if tray name includes phone number
   * @private
   */
  includesPhoneNumber(trayName, phoneNumber, supportDetails) {
    if (supportDetails && trayName === supportDetails.technicalSupportPhoneDisplayOnly) {
      return true;
    }
    return trayName.indexOf(phoneNumber) !== -1;
  }

  /**
   * Whether to show the city contacts tray
   *
   * Only shows the tray if there exists a city contact with a phone number that
   * does not match the market contact
   *
   * @param {Object} supportDetails Information from the support API
   * @returns {Boolean} true if we should show the city contacts tray, false otherwise
   * @private
   */
  shouldShowCityContactsTray(supportDetails) {
    if (!supportDetails || !supportDetails.cityContacts) return false;
    const cityContactKeys = Object.keys(supportDetails.cityContacts);
    for (let idx = 0; idx < cityContactKeys.length; idx++) {
      const contact = supportDetails.cityContacts[cityContactKeys[idx]];
      if (contact.technicalSupportPhone !== supportDetails.technicalSupportPhone) {
        return true;
      }
    }
    return false;
  }

  /**
   * Render the phone icon along with appropriate alternate text
   *
   * @returns {React.ReactElement} A `span` element with the phone icon and specified alt text
   * @param {Boolean} showContactTrayForHelpCenter whether there is a dropdown tray or contact-us link
   * @private
   */
  renderIcon() {
    let showContactTrayForHelpCenter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const props = this.props;
    // chat icon below added for experiment https://godaddy-corp.atlassian.net/browse/UXP-8209
    return /*#__PURE__*/_react.default.createElement("span", {
      title: props.messages[_enums.golf.contactUs],
      className: "phone-header"
    }, showContactTrayForHelpCenter ? /*#__PURE__*/_react.default.createElement(_phone.default, null) : /*#__PURE__*/_react.default.createElement(_chat.default, null));
  }
  renderCityContacts(supportDetails) {
    const altContactsData = [];
    // Push alternative contacts
    if (supportDetails.cityContacts && Object.keys(supportDetails.cityContacts).length) {
      Object.keys(supportDetails.cityContacts).forEach(key => {
        altContactsData.push(supportDetails.cityContacts[key]);
      });
    }
    // If no city contacts were found, use market contact
    // Make sure to use technicalSupportDescription for the market contact
    if (!altContactsData.length) {
      altContactsData.push({
        technicalSupportPhone: supportDetails.technicalSupportPhone,
        technicalSupportHours: supportDetails.technicalSupportDescription,
        technicalSupportPhoneDisplayOnly: supportDetails.technicalSupportPhoneDisplayOnly
      });
    }
    const altContacts = altContactsData.map((contact, idx) => {
      const altPhone = contact.technicalSupportPhone || '';
      const displayPhone = contact.technicalSupportPhoneDisplayOnly || altPhone;
      const hrefPhoneNumber = `tel:${altPhone.replace(/[^+\d]/g, '')}`;
      // If {phone} make the number a telHref otherwise link to contact us
      const trayNameEid = this.includesPhoneNumber ? `uxp.hyd.utility_bar.support_phone.click` : this.eids.contactUs;
      return /*#__PURE__*/_react.default.createElement("li", {
        key: idx
      }, /*#__PURE__*/_react.default.createElement("span", null, contact.technicalSupportHours), /*#__PURE__*/_react.default.createElement("a", {
        className: "contact-link",
        "data-eid": trayNameEid,
        href: hrefPhoneNumber
      }, displayPhone));
    });
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "alt-contact-list"
    }, altContacts);
  }
  renderFederatedPartner() {
    const props = this.props;
    if (!props.federatedPartner) {
      return null;
    }
    const {
      phone,
      phoneDescription
    } = props.federatedPartner;
    const hrefPhoneNumber = `tel:${phone.replace(/[^+\d]/g, '')}`;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "federated-partner"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "partner-description"
    }, phoneDescription), /*#__PURE__*/_react.default.createElement("a", {
      href: hrefPhoneNumber,
      className: "contact-link",
      "data-eid": "uxp.hyd.utility_bar.federated_phone.click"
    }, phone));
  }
  renderCityContactsTray(supportDetails, trayName, includesPhoneNumber) {
    const trayLabel = this.renderTrayName(trayName, includesPhoneNumber);
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.contactUs
    }, contactUs => /*#__PURE__*/_react.default.createElement(_trayMenu.TrayMenu, {
      ariaLabel: contactUs,
      "data-eid": "uxp.hyd.utility_bar.city_contact_tray.tray.click",
      type: "base",
      className: "city-contacts-tray",
      name: trayLabel
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:SupportPhone:Alternate:Numbers"
    })), this.renderCityContacts(supportDetails), this.renderFederatedPartner(), this.renderSupportAnnouncement(supportDetails.technicalSupportAnnouncement)))));
  }
  renderFullTray(supportDetails, trayName, includesPhoneNumber) {
    const props = this.props;
    const eids = this.eids;
    const trayLabel = this.renderTrayName(trayName, includesPhoneNumber);
    return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.contactUs
    }, contactUs => /*#__PURE__*/_react.default.createElement(_trayMenu.TrayMenu, {
      ariaLabel: contactUs,
      "data-eid": "uxp.hyd.utility_bar.contact_tray.tray.click",
      type: "base",
      className: "contact-tray",
      name: trayLabel
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-wrap"
    }, this.renderSupportAnnouncement(supportDetails.technicalSupportAnnouncementAllChannels, true, {
      label: supportDetails.technicalSupportAnnouncementBtnText,
      href: supportDetails.technicalSupportAnnouncementBtnHref
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content-wrap"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:SupportPhone:CallUs"
    })), this.renderCityContacts(supportDetails), this.renderFederatedPartner(), /*#__PURE__*/_react.default.createElement("div", {
      className: "contact-link-info"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:SupportPhone:GlobalDirectory:GlobalDirectory"
    })), /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      urlArgs: props.urlArgs
    }, props.urls.contactUs, {
      "data-eid": eids.globalDirectory,
      className: "contact-link"
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.globalDirectory
    }))), this.renderRequestACall(), (0, _componentUtilities.isMobile)(props.breakpoint) || props.breakpoint === 'tablet' ? this.renderMobileChatSection(supportDetails) : this.renderChatSection(supportDetails), /*#__PURE__*/_react.default.createElement("div", {
      className: "help-mobile"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:SupportPhone:HelpCenter"
    })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:SupportPhone:HelpCenter:Explore"
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      className: "ux-button ux-button-secondary",
      urlArgs: props.urlArgs
    }, props.urls.help, {
      "data-eid": eids.help
    }), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: _enums.golf.help
    }))))), this.renderSupportAnnouncement(supportDetails.technicalSupportAnnouncement))));
  }
  showSupportContacts() {
    this.setState({
      showPhoneNumbers: true
    });
  }
  renderChatSection(supportDetails) {
    // Make chat data available in a global so chat team code can render it
    if ((0, _componentUtilities.isBrowser)()) {
      const uxel = window && window.ux && window.ux.eldorado;
      if (uxel) {
        const messages = this.props.messages;
        uxel.chat_data = {
          target: 'gdchat-container',
          utilityChatEnabled: this.props.utilityChatEnabled,
          messages: {
            ChatNow: messages['Shared:UtilityBar:SupportPhone:ChatNow'],
            Chat: messages['Shared:UtilityBar:SupportPhone:Chat'],
            ChatOffline: messages['Shared:UtilityBar:SupportPhone:ChatOffline'],
            ChatHours: supportDetails.liveChatHours
          }
        };
      }
    }

    // IMPORTANT: `#gdchat-container` is used by the Chat team to render their chat UI into.
    // Do not remove it or change it without talking to @clim & @mfloyd
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "gdchat-container"
    });
  }
  renderMobileChatSection(supportDetails) {
    const showMobileChatSection = this.props.utilityChatEnabled && supportDetails.liveChatHours && supportDetails.contactTrayChatDescription && supportDetails.contactTrayButtonLink;
    if (!showMobileChatSection) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "chat-mobile"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:SupportPhone:ChatNow"
    })), /*#__PURE__*/_react.default.createElement("p", null, supportDetails.contactTrayChatDescription, ' ', /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", null, supportDetails.liveChatHours)), /*#__PURE__*/_react.default.createElement("div", null, supportDetails.contactTrayButtonLink ? /*#__PURE__*/_react.default.createElement("span", {
      className: "mobile-chat-btn-wrap"
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      className: "ux-button ux-button-primary mobile-chat-btn",
      urlArgs: this.props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.chat_support_btn.click",
      href: supportDetails.contactTrayButtonLink
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Shared:UtilityBar:SupportPhone:ChatNow"
    }))) : null), supportDetails.WhatsAppButtonLink && supportDetails.WhatsAppPhoneNumber ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "whatsapp-container"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "whatsapp-chat-btn"
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      className: "ux-button ux-button-secondary",
      urlArgs: this.props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.whatsapp_chat_btn.click",
      href: supportDetails.WhatsAppButtonLink
    }, /*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true",
      className: "whatsapp-icon"
    }, /*#__PURE__*/_react.default.createElement("svg", {
      role: "img",
      width: "16",
      height: "16",
      viewBox: "24 10 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react.default.createElement("path", {
      d: "M44.504 13.488A11.877 11.877 0 0040.63 10.9 11.924 11.924 0 0036.05 10c-6.59 0-11.948 5.335-11.95 11.892a11.826 11.826 0 001.595 5.945L24 34l6.335-1.654a11.987 11.987 0 005.71 1.448h.005c6.586 0 11.948-5.336 11.95-11.893a11.772 11.772 0 00-.902-4.555 11.818 11.818 0 00-2.594-3.858zm-8.453 18.297h-.006a9.955 9.955 0 01-5.056-1.378l-.362-.214-3.76.981 1.004-3.65-.236-.373a9.83 9.83 0 01-1.517-5.257c0-5.45 4.458-9.884 9.937-9.884a9.958 9.958 0 017.022 2.9 9.862 9.862 0 012.906 6.99c-.002 5.45-4.458 9.885-9.932 9.885zm5.448-7.403c-.299-.149-1.767-.868-2.04-.97-.275-.1-.473-.147-.672.15-.2.297-.771.97-.946 1.165-.174.195-.348.223-.647.074-.298-.148-1.26-.462-2.401-1.475-.888-.787-1.487-1.76-1.662-2.059-.175-.297-.018-.456.132-.606.134-.133.298-.347.447-.52.149-.174.2-.298.298-.496.1-.198.05-.372-.024-.52-.075-.15-.672-1.612-.92-2.207-.243-.58-.49-.501-.672-.51-.172-.009-.374-.01-.574-.01a1.101 1.101 0 00-.796.371c-.273.298-1.044 1.017-1.044 2.48 0 1.462 1.07 2.875 1.218 3.074.15.198 2.106 3.2 5.1 4.486.556.239 1.124.448 1.702.627.716.229 1.367.194 1.88.118.574-.085 1.768-.719 2.017-1.413.248-.694.248-1.289.172-1.413-.077-.125-.27-.197-.568-.346z"
    }))), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Sales:ContactTray:WhatsApp:ChatButton"
    }))), /*#__PURE__*/_react.default.createElement("p", null, supportDetails.WhatsAppPhoneNumber))) : null);
  }
  renderRequestACall() {
    const props = this.props;
    if (!props.requestACallEnabled) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "request-a-call"
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayTitle, null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Sales:ContactTray:RequestACall:CTA"
    })), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Sales:ContactTray:RequestACall:avoidTheWait"
    })), /*#__PURE__*/_react.default.createElement(_link.default, (0, _extends2.default)({
      className: "ux-button ux-button-secondary",
      urlArgs: props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.request_a_call.click"
    }, props.urls.requestACall), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: "Sales:ContactTray:RequestACall:CTA"
    })));
  }

  /**
   * Render the support announcement section if needed
   *
   * @param {Object} announcement value from supportDetails.technicalSupport{AllChannels}
   * @param {boolean} [allChannels] flag denoting whether we're rendering the `AllChannels` support announcement
   * @param {Object} [buttonInfo] settings for the button to show next to the AllChannels announcement if applicable
   * @returns {React.ReactElement} The support announcement as a React element, or null if none needed
   */
  renderSupportAnnouncement(announcement) {
    let allChannels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let buttonInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const className = allChannels ? 'support-announcement-all' : 'support-announcement';
    const announcementsTemplate = /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "support-announcement-text"
    }, /*#__PURE__*/_react.default.createElement(_information.default, null), announcement), buttonInfo.href ? /*#__PURE__*/_react.default.createElement("span", {
      className: "support-announcement-btn"
    }, /*#__PURE__*/_react.default.createElement(_link.default, {
      className: "ux-button ux-button-secondary ux-button-small",
      urlArgs: this.props.urlArgs,
      "data-eid": "uxp.hyd.utility_bar.support_announcement_btn.click",
      href: buttonInfo.href
    }, buttonInfo.label)) : null);
    if (announcement) {
      if (!allChannels) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, announcementsTemplate);
      }
      return announcementsTemplate;
    }
    return null;
  }
}
exports.ContactTray = ContactTray;
ContactTray.propTypes = {
  supportContacts: _propTypes.default.object.isRequired,
  shopperId: _propTypes.default.string,
  contactTrayEnabled: _propTypes.default.bool,
  requestACallEnabled: _propTypes.default.bool,
  utilityChatEnabled: _propTypes.default.bool,
  manifest: _propTypes.default.string,
  market: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object.isRequired,
  privateLabelId: _propTypes.default.number,
  urls: _propTypes.default.object,
  urlArgs: _propTypes.default.object,
  split: _propTypes.default.string,
  federatedPartner: _propTypes.default.object,
  features: _propTypes.default.shape({
    showContactTrayForHelpCenter: _propTypes.default.bool,
    contactTrayHelpLink: _propTypes.default.string
  }).isRequired,
  breakpoint: _propTypes.default.string.isRequired
};
ContactTray.defaultProps = {
  contactTrayEnabled: false,
  requestACallEnabled: false,
  utilityChatEnabled: false
};
function ContactTrayWrapper(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(..._enums.breakpoints);
  return /*#__PURE__*/_react.default.createElement(ContactTray, (0, _extends2.default)({
    breakpoint: breakpoint
  }, props));
}